const fn =  (state = {}, action) => {
	switch (action.type) {
		case 'SET_AGENCY_PROJECTS':
			return Object.assign({}, state, action.payload)
		default:
			return state
	}
}

export default fn